import RoutesMap from "../../route_control/RouteControl"
import {
    BrandList,
    AddBrand,
    UpdateBrand,
    SubCategoryList,
    AddSubCategory,
    UpdateSubCategory,
    ItemList,
    AddItem,
    UpdateItem,
    MeasureUnitList,
    AddMeasureUnit,
    UpdateMeasureUnit,
    MeasureUnitTypeList,
    AddMeasureUnitType,
    UpdateMeasureUnitType,
    ProductPricingList,
    UpdateProductPricing,
    CustomerPricingList,
    UpdateCustomerPricing,
    CustomerCategoryPricingList,
    UpdateCustomerCategoryPricing,
    ColorList,
    AddColor,
    UpdateColor,
    SegmentList,
    AddSegment,
    UpdateSegment,
    RackList,
    AddRack,
    UpdateRack,
    GenerateDeliveryNote,
    DeliveryNoteList,
    PaymentList,
    AddPayment,
    InvoiceList,
    AddInvoice,
    StockReject,
} from "../../pages/inventory"

export const InventoryImport = {
    RoutesMap,
    BrandList,
    AddBrand,
    UpdateBrand,
    SubCategoryList,
    AddSubCategory,
    UpdateSubCategory,
    ItemList,
    AddItem,
    UpdateItem,
    MeasureUnitList,
    AddMeasureUnit,
    UpdateMeasureUnit,
    MeasureUnitTypeList,
    AddMeasureUnitType,
    UpdateMeasureUnitType,
    ProductPricingList,
    UpdateProductPricing,
    CustomerPricingList,
    UpdateCustomerPricing,
    CustomerCategoryPricingList,
    UpdateCustomerCategoryPricing,
    ColorList,
    AddColor,
    UpdateColor,
    SegmentList,
    AddSegment,
    UpdateSegment,
    RackList,
    AddRack,
    UpdateRack,
    GenerateDeliveryNote,
    DeliveryNoteList,
    PaymentList,
    AddPayment,
    InvoiceList,
    AddInvoice,
    StockReject,
}